/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import {
  Switch,
  Flex,
  Text,
  Spinner,
  Button,
  useToast,
  useDisclosure,
  AlertDialog,
  AlertDialogFooter,
  AlertDialogBody,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
} from '@chakra-ui/react';
import { axiosInstance } from '@partiu/api/axios';
import { useTheme } from '@partiu/ui/contexts/ThemeProvider';

interface ToggleEmailProps {
  onComplete: () => void;
}

const ToggleEmail: React.FC<ToggleEmailProps> = ({ onComplete }) => {
  const [isToggled, setIsToggled] = useState(false);
  const theme = useTheme();
  const [loading, setLoading] = useState(false);

  const handleImportButton = useDisclosure();
  const imporstRef: any = React.useRef<any>();

  const toast = useToast();

  const handleToggle = async () => {
    try {
      const response = await axiosInstance.post('/agreement_staff/toggle_send_books_by_email/');

      if (response.status === 200) {
        setIsToggled(!isToggled);
      } else {
        console.error('Failed to toggle');
      }
    } catch (error) {
      console.error('Error toggling:', error);
    }
  };

  const handleImport = async () => {
    setLoading(true);
    try {
      await axiosInstance.post('/agreement_staff/request-prospected-client/');

      toast({
        title: 'Sucesso',
        description: 'Email esta sendo importado, aguarde...',
        status: 'success',
        duration: 9000,
        isClosable: true,
      });
      if (onComplete) {
        onComplete();
      }
      handleImportButton.onOpen();
    } catch (error) {
      console.error('Error toggling:', error);
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    setIsToggled(theme.enableSendingBookEmail);
  }, [theme]);

  return (
    <Flex flexDirection={'column'} gap="20px">
      <Flex>
        <Button
          variant="outline"
          colorScheme="teal"
          width="200px"
          backgroundColor={theme.colors.primaryColor}
          color="white"
          _hover={{ backgroundColor: theme.colors.primaryColor }}
          _active={{ backgroundColor: theme.colors.primaryColor }}
          _focus={{ boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.6)' }}
          onClick={handleImport}
          isLoading={loading}
          isDisabled={loading}
        >
          Importar Emails
        </Button>
      </Flex>

      <Flex alignItems="center" gap="10px">
        <Switch isChecked={isToggled} onChange={handleToggle} isDisabled={loading} colorScheme="teal" />

        <Text fontSize="sm" color="gray.600">
          {isToggled
            ? 'Desabilitar envio de notificações por email'
            : 'Habilitar envio de notificações por email para os usuários importados'}
        </Text>
      </Flex>

      <AlertDialog
        leastDestructiveRef={imporstRef}
        isOpen={handleImportButton.isOpen}
        onClose={handleImportButton.onClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Importação Iníciada
            </AlertDialogHeader>

            <AlertDialogBody>
              Os email estão sendo importados, esse processo pode demorar alguns minutos, por favor aguarde. ira ser
              retornar o status e mostrará a quantidade de usuarios elegíveis
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button onClick={handleImportButton.onClose}>Fechar</Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </Flex>
  );
};

export default ToggleEmail;
